import template from './date_single_picker.html.slim';

angular.module('wbComponents').directive('wbDateSinglePicker', function() {
  return {
    replace: true,
    restrict: 'E',
    controllerAs: 'ctrl',
    bindToController: true,
    scope: {
      date: '=',
      value: '=',
      startDate: '=',
      endDate: '=',
      active: '=',
      dateClicked: '&',
      blockWeekends: '@'
    },
    templateUrl: template,

    controller() {
      this.dateSelected = date => {
        this.date = date;
        this.dateClicked({date});
        return this.active = false;
      };

      this.isSelected = date => {
        return moment(date).isSame(this.date, 'd');
      };

      return this;
    },

    link($scope, $el, $attrs) {
      $('html').on('click', function(e) {
        if ($.contains($el[0], e.target)) { return; }
        $scope.ctrl.active = false;
      });

      return $el.on('click', e => e.stopImmediatePropagation());
    }
  };
});
